<template>
    <div>
        <img
            v-if="type === 'hospitalization'"
            src="@/assets/icons/hospitalization.svg"
        />
        <img
            v-else-if="type === 'discharge'"
            src="@/assets/icons/discharge.svg"
        />
        <img
            v-else-if="type === 'basalstudy'"
            src="@/assets/icons/basal_study.svg"
        />
        <img
            v-else-if="type === 'surgery'"
            src="@/assets/icons/surgery.svg"
        />
        <img
            v-else-if="type === 'readmission'"
            src="@/assets/icons/readmission.svg"
        />
        <img
            v-else
            src="@/assets/icons/surgery.svg"
            class="invisible"
        />
    </div>
</template>

<script>
    export default {
        name: "TimelineIcon",
        props: {
            type: {
                type: String,
                required: true,
            },
        },
    };
</script>

<style scoped>

</style>